module.exports = __webpack_public_path__ + "static/media/19.2eaa9d2b.jpg";